import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";
import { AuthService } from '../../services/auth.service';
import { UserIdentity } from "../../models/user-identity.model";

// Checks if user has logged in
@Injectable()
export class BaseGuardService  {

    constructor(
        public authService: AuthService,
        public router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        let obs$: Observable<boolean | UrlTree>;
        const unauthorized$ = of(this.router.createUrlTree(['/home/unauthorized', { ref: state.url }], /* Removed unsupported properties by Angular migration: skipLocationChange. */ {}));
        obs$ = this.authService.token$.pipe(
            take(1),
            mergeMap((token: string) => {
            let returnObs$: Observable<boolean | UrlTree> = of(false);            
            if (token == null || token === "") {
                returnObs$ = this.authService.setProfile().pipe(mergeMap((identity: UserIdentity) => {
                    return (identity.isLoggedIn)
                        ? of(true)
                        : unauthorized$;
                }));
            }
            else {
                returnObs$ = of(this.authService.isLoggedIn).pipe(
                    mergeMap((isLoggedIn: boolean) => {
                        return (isLoggedIn)
                            ? of(true)
                            : unauthorized$;
                    })
                );                
            }
            return returnObs$;
        }))
        return obs$;
    }   
}
